import { Divider, TextInput, Title } from '@mantine/core';
import { useEffect, useState } from 'react';
import { EditorItem, useEditorStore } from '../../store/editorStore';

interface VariableItemPanelProps {
  item: EditorItem;
  handleUpdate: (updates: Partial<EditorItem>) => void;
}

export function VariableItemPanel({ item, handleUpdate }: VariableItemPanelProps) {
  const updateItem = useEditorStore((state) => state.updateItem);
  
  // Tách tên biến và giá trị từ content
  const [name, setName] = useState('');
  const [value, setValue] = useState('');
  
  useEffect(() => {
    // Format của content: name=value
    const parts = item.content.split('=');
    if (parts.length >= 2) {
      setName(parts[0]);
      setValue(parts.slice(1).join('='));  // Đề phòng giá trị có chứa dấu =
    } else {
      setName(item.content);
      setValue('');
    }
  }, [item.content]);
  
  // Cập nhật content khi name hoặc value thay đổi
  const updateVariable = () => {
    const newContent = value ? `${name}=${value}` : name;
    handleUpdate({ content: newContent });
  };
  
  return (
    <>
      <Title order={4}>Thuộc tính biến</Title>
      
      <TextInput
        label="Tên biến"
        value={name}
        onChange={(e) => {
          setName(e.target.value);
          // Cập nhật ngay khi người dùng thay đổi
          setTimeout(() => updateVariable(), 0);
        }}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      />
      
      <Divider my="xs" />
      
      <TextInput
        label="Giá trị biến"
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          // Cập nhật ngay khi người dùng thay đổi
          setTimeout(() => updateVariable(), 0);
        }}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        placeholder="Nhập giá trị thay thế"
      />
    </>
  );
} 